import { ocpStageOption } from "@/lib/utils";

const useOCPDocTypes = () => {
  // Define Table Columns
  const columns = [
    {
      accessorKey: "documentCode",
      header: "Doc Code",
      accessorFn: (row: any) => String(row?.documentCode || ""),
    },
    {
      accessorKey: "ocpStage",
      header: "OCP Stage",
      accessorFn: (row: any) => ocpStageOption?.find((data: any) => data?.value == row?.ocpStage)?.label  || "",
    },
    {
      accessorKey: "maxFileSizeMb",
      header: "Max File Size",
      accessorFn: (row: any) => String(row?.maxFileSizeMb || ""),
    },
  ];

  return {
    columns
  };
};

export default useOCPDocTypes;
